export const subjects = (state) => {
  return state.subjects;
};

export const bookmarks = (state) => {
  return state.bookmarks;
};
